<template>
  <div class="invite-page-skeleton">
    <div class="skeleton-panel">
      <div class="skeleton-row skeleton-row-between">
        <div class="skeleton-line skeleton-line-md"></div>
        <div class="skeleton-line skeleton-line-sm"></div>
      </div>
      <div class="skeleton-divider"></div>
      <div class="skeleton-row skeleton-row-between">
        <div class="skeleton-line skeleton-line-lg"></div>
        <div class="skeleton-block skeleton-block-btn"></div>
      </div>
      <div class="skeleton-line skeleton-line-xl"></div>
      <div class="skeleton-line skeleton-line-md skeleton-line-short"></div>
    </div>

    <div class="skeleton-tabs">
      <div class="skeleton-block skeleton-tab"></div>
      <div class="skeleton-block skeleton-tab"></div>
    </div>

    <div class="skeleton-summary">
      <div class="skeleton-line skeleton-line-lg"></div>
      <div class="skeleton-line skeleton-line-sm"></div>
    </div>

    <div class="skeleton-card" v-for="n in 3" :key="n">
      <div class="skeleton-line skeleton-line-md"></div>
      <div class="skeleton-line skeleton-line-sm skeleton-line-short"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvitePageSkeleton',
}
</script>

<style lang="scss" scoped>
@keyframes invite-skeleton-pulse {
  0% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 0.45;
  }
}

.invite-page-skeleton {
  width: 343px;
  margin: 0 auto;
  padding-bottom: 24px;
  background: #fefefe;
  border-radius: 0 0 16px 16px;
  overflow: hidden;

  .skeleton-panel {
    padding: 16px;
    background: #ffffff;
    border-radius: 16px;
  }

  .skeleton-row {
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 8px;
    }

    &.skeleton-row-between {
      justify-content: space-between;
    }
  }

  .skeleton-divider {
    height: 1px;
    margin: 12px 0;
    background: #ededed;
  }

  .skeleton-line,
  .skeleton-block {
    border-radius: 6px;
    background: #ece7df;
    animation: invite-skeleton-pulse 1.2s ease-in-out infinite;
  }

  .skeleton-line {
    height: 16px;
    flex: 1;

    &.skeleton-line-sm {
      max-width: 72px;
      height: 14px;
    }

    &.skeleton-line-md {
      max-width: 120px;
      height: 18px;
    }

    &.skeleton-line-lg {
      max-width: 160px;
      height: 22px;
    }

    &.skeleton-line-xl {
      width: 200px;
      max-width: 70%;
      height: 32px;
      margin-top: 8px;
    }

    &.skeleton-line-short {
      max-width: 96px;
      margin-top: 6px;
    }
  }

  .skeleton-block-btn {
    width: 88px;
    height: 34px;
    border-radius: 24px;
    flex-shrink: 0;
  }

  .skeleton-tabs {
    display: flex;
    padding: 8px 12px 16px;
    background: #fefefe;

    > * + * {
      margin-left: 8px;
    }
  }

  .skeleton-tab {
    flex: 1;
    height: 40px;
    border-radius: 24px;
  }

  .skeleton-summary {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px 16px;

    > * + * {
      margin-top: 8px;
    }

    .skeleton-line-lg {
      width: 120px;
      flex: none;
    }

    .skeleton-line-sm {
      width: 160px;
      flex: none;
    }
  }

  .skeleton-card {
    margin: 0 12px 12px;
    padding: 16px;
    border-radius: 12px;
    background: #f9f9f9;
  }
}
</style>
